import '@swc/helpers';
import 'react';
import { useBrPageContext } from '../context/context.js';
import '@bloomreach/react-sdk';
import '../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import { getBrPageContent } from '../utils/get-br-page-content.js';
import '@grandvisionhq/utils';
import '@grandvisionhq/common';
import '../utils/http-client.js';
import { useBloomreachPageModels } from './use-bloomreach-page-models.js';

const useBloomreachProtectionInfo = ()=>{
    const page = useBrPageContext();
    const pageModels = useBloomreachPageModels();
    if (!page) {
        return undefined;
    }
    // In the Bloomreach CMS, the protection info is stored in the protectionConfigurationDocument
    const reference = pageModels === null || pageModels === void 0 ? void 0 : pageModels.protectionConfiguration;
    if (!reference) {
        return undefined;
    }
    // The $ref is the unique identifier for the donation info
    const protectionDocumentContent = getBrPageContent(page, reference);
    if (!protectionDocumentContent) {
        console.warn(`Cannot find main content for Protection Info. Got: ${protectionDocumentContent} for $ref: ${reference.$ref}`);
        return undefined;
    }
    const protectionInfoImageContent = protectionDocumentContent.coverImage && (page === null || page === void 0 ? void 0 : page.getContent(protectionDocumentContent.coverImage));
    return {
        title: protectionDocumentContent.title,
        content: protectionDocumentContent.content,
        image: {
            url: protectionInfoImageContent === null || protectionInfoImageContent === void 0 ? void 0 : protectionInfoImageContent.getOriginal().getUrl(),
            alt: protectionInfoImageContent === null || protectionInfoImageContent === void 0 ? void 0 : protectionInfoImageContent.getDescription()
        }
    };
};

export { useBloomreachProtectionInfo };
//# sourceMappingURL=use-bloomreach-protection.js.map
